import styled, { css } from "styled-components";
import { ColorTokens, breakpoints } from "@tvg/design-system";

const flexColumn = css`
  display: flex;
  flex-direction: column;
`;

const handleColor = (
  isTopStat: boolean | undefined,
  colorTokens: ColorTokens
) => (isTopStat ? colorTokens.background.positive : colorTokens.content.subtle);

const handleMarginLeft = (hasSilk: boolean) => (hasSilk ? "68" : "40");

export const PerformanceContainer = styled.div<{
  isScratched: boolean | undefined;
  isInlineHandicapping?: boolean;
  hasSilk: boolean;
  hasMobileOrder?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  ${({ isInlineHandicapping, hasSilk }) =>
    !isInlineHandicapping &&
    css`
      margin-left: ${handleMarginLeft(hasSilk)}px;
    `}
  padding: ${({ theme }) =>
    `0 ${theme.space["space-4"]} ${theme.space["space-4"]} ${theme.space["space-4"]}`};
  ${({ isScratched }) =>
    isScratched &&
    css`
      opacity: 0.4;
    `};

  @media screen and ${breakpoints.tablet.max.sm} {
    order: ${({ hasMobileOrder }) => (hasMobileOrder ? 1 : "initial")};
    margin-left: 0;
  }
`;
export const SectionContainer = styled.div<{
  isFirstSection?: boolean;
  isSecondSection?: boolean;
  isThirdSection?: boolean;
}>`
  display: flex;
  ${({ isFirstSection }) =>
    isFirstSection &&
    css`
      justify-content: flex-start;
      gap: 17px;
    `}

  ${({ isSecondSection }) =>
    isSecondSection &&
    css`
      justify-content: center;
      gap: 8px;
    `}

    ${({ isThirdSection }) =>
    isThirdSection &&
    css`
      justify-content: flex-end;
      gap: 24px;
    `}

  @media screen and ${breakpoints.tablet.max.sm} {
    flex-direction: column;
    gap: 4px;
  }
`;

export const InfoContainer = styled.div<{
  isFirstSection?: boolean;
}>`
  ${flexColumn};
  text-align: center;

  @media screen and ${breakpoints.tablet.max.sm} {
    flex-direction: row-reverse;
    align-items: center;
    text-align: left;
    justify-content: ${({ isFirstSection }) =>
      isFirstSection ? "flex-end" : "space-between"};
  }
`;

export const Info = styled.span<{
  isValue?: boolean;
  isTopStat?: boolean;
  isDescription?: boolean;
}>`
  white-space: nowrap;
  font-size: 12px;
  color: ${({ isDescription, isTopStat, theme }) =>
    isDescription
      ? theme.colorTokens.content.subtle2
      : handleColor(isTopStat, theme.colorTokens)};
  font-family: ${({ theme }) => theme.fonts.condensedRegular};
  line-height: 13.2px;
  ${({ isValue, theme }) =>
    isValue &&
    css`
      font-family: ${theme.fonts.medium};
      font-size: 14px;
      line-height: 17.5px;
      padding: 2px 8px 2px 8px;
    `};

  @media screen and ${breakpoints.tablet.max.sm} {
    line-height: 1;
    ${({ isValue }) =>
      isValue &&
      css`
        padding: 0;
        margin: 0 0 0 4px;
      `};
  }
`;
